<template>
  <div class="result">
    asd
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'CitySearchResult',
  data () {
    return {
      dorms: null
    }
  },
  methods: {
    getDorms () {
      let self = this
      const type = this.$route.params.type
      if (type === 'sehir') {
        axios.get(`/site/cities/dorms/${this.$route.params.id}`)
          .then(response => {
            self.dorms = response.data.data
            // console.log(self.dorms)
          })
          .catch(e => {
            this.errors.push(e)
          })
      } else if (type === 'universite') {
        axios.get(`/site/cities/dorms/${this.$route.params.id}`)
          .then(response => {
            self.dorms = response.data.data
            // console.log(self.dorms)
          })
          .catch(e => {
            this.errors.push(e)
          })
      }
    }
  },
  created () {
    this.getDorms()
  }
}
</script>

<style scoped>

</style>
